import { BOOKINGS_APP_DEF_ID, MEMBERS_AREA_SECTION_ID, MY_BOOKINGS_PLUGIN_ID, SANTA_MEMBERS_APP_ID } from './consts';
let membersAreaApi;
const getMembersAreaAPI = async wixCodeApi => {
  if (!membersAreaApi) {
    const api = await wixCodeApi.site.getPublicAPI(SANTA_MEMBERS_APP_ID);
    membersAreaApi = api;
  }
  return membersAreaApi;
};
export const navigateToMembersArea = async wixCodeApi => {
  const {
    navigateToSection
  } = await getMembersAreaAPI(wixCodeApi);
  try {
    const rescheduleRedirectUrl = new URL(wixCodeApi.location.query.rescheduleRedirectUrl).toString();
    if (rescheduleRedirectUrl) {
      wixCodeApi.location.to == null || wixCodeApi.location.to(rescheduleRedirectUrl);
      return;
    }
  } catch (e) {
    console.error('navigateToMemberArea: failed to redirect to rescheduleRedirectUrl', e);
  }
  await navigateToSection({
    appDefinitionId: BOOKINGS_APP_DEF_ID,
    sectionId: MEMBERS_AREA_SECTION_ID,
    widgetId: MY_BOOKINGS_PLUGIN_ID,
    memberId: wixCodeApi.user.currentUser.id
  });
};
//# sourceMappingURL=navigate-to-members-area.js.map